import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog';
import { Content, Header } from '@jetbrains/ring-ui/components/island/island';
import Panel from '@jetbrains/ring-ui/components/panel/panel';
import Button from '@jetbrains/ring-ui/components/button/button';
import CopiedCode from '@common/clipboard/copied-code/copied-code';
export function LicensePublicKeyDialog({ licenseData, onCloseAttempt }) {
    return (_jsxs(Dialog, { show: true, onCloseAttempt: onCloseAttempt, children: [_jsx(Header, { children: "License Public Key" }), _jsx(Content, { children: licenseData ? _jsx(CopiedCode, { text: licenseData.publicKey }) : 'Public key is not available' }), _jsx(Panel, { children: _jsx(Button, { onClick: onCloseAttempt, children: "Cancel" }) })] }));
}
